/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * smoothScrollToTopBtn.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ページトップボタン
 */

const ToTopBtn = document.getElementById('totop');

function scrollToTopBtn() {
	ToTopBtn.addEventListener('click', scrollToTop);

	function scrollToTop() {
		window.scroll({
			top: 0,
			behavior: 'smooth'
		});
	}
}

/**
 * 表示・非表示アクション
 */
function toTopBtnScrollEvent() {
	window.addEventListener('scroll', scroll_event);

	function scroll_event() {
		if (window.pageYOffset > 400) {
			ToTopBtn.style.opacity = '1';
		} else if (window.pageYOffset < 400) {
			ToTopBtn.style.opacity = '0';
		}
	}
}

export {
	scrollToTopBtn
};